import { alpha } from "@mui/material";
import { Grid, LinearProgress, Stack, theme, Typography } from "@mzc-pdc/ui";
import React from "react";

export const LinearProgressDeterminate = ({ sx, withLabel = false, speed, ...rest }) => {
    return (
        <Grid item sx={{ width: "100%", display: "flex", flexDirection: "row", alignItems: "center", gap: "10px" }}>
            <LinearProgress
                variant={"determinate"}
                {...rest}
                sx={{
                    flex: 1,
                    height: "6px",
                    borderRadius: "3px",
                    backgroundColor: alpha(theme.palette.greySecondary[50], 0.5),
                    "& .MuiLinearProgress-bar": {
                        height: "6px",
                        borderRadius: "3px",
                    },
                    ...sx,
                }}
            />
            {withLabel && (
                <Stack direction={"row"} gap={"10px"}>
                    <Typography variant="body2_400" color="text.secondary" sx={{ flexGrow: 0 }}>{`${Math.round(
                        rest?.value,
                    )}%`}</Typography>
                    {speed !== undefined && (
                        <Typography
                            variant="body2_700"
                            color="primary"
                            sx={{ flexGrow: 0, width: "60px", alignSelf: "flex-end" }}
                        >{`${speed}Mb/s`}</Typography>
                    )}
                </Stack>
            )}
        </Grid>
    );
};
